import {
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  FormLabel,
} from "@chakra-ui/react";
import { Field } from "formik";

const ChakraInput = (props) => {
  const {
    label,
    name,
    isRequired,
    fontSize,
    isDisabled = false,
    type = "text",
  } = props;

  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        return (
          <FormControl
            id={name}
            isRequired={isRequired}
            isInvalid={form.errors[name] && form.touched[name]}
          >
            <FormLabel fontWeight="bold" fontSize={fontSize}>
              {label}
            </FormLabel>
            <InputGroup>
              <Input
                bg="white"
                type={type}
                id={name}
                name={name}
                {...field}
                isDisabled={isDisabled}
              ></Input>
            </InputGroup>
            {meta.touched && meta.error && (
              <FormErrorMessage>{form.errors[name]}</FormErrorMessage>
            )}
          </FormControl>
        );
      }}
    </Field>
  );
};

export default ChakraInput;
